import React, { useState, useEffect } from "react";

import rApp from "./rapp";
import { util } from "./util";
import Variants from "./variants";
import EmbVariants from "./embVariants";
import { NeedleIcon } from "./icons";
import EmbVariantsApplique from "./embVariantsApplique";
import ProductBanner from "./productBanner";

const visitorCountry = window.Shopify?.country || 'US'; // Defaults to 'US' if not available
// Hardcoded conversion rate for USD to CAD
const conversionRateCAD = 1.38;
const getCurrency = () => {
  const marketHandle =window.Shopify?.country || 'US';
  return marketHandle == 'CA' ? 'CAD' : 'USD';
};

const ProductMeta = ({
  embroideryPricing,
  thisProductPage,
  productObject,
  productOptionVals,
  productAdditionalVariantField,
  selectedFont,
  setProductClassCurrentVariant,
  setProductSliderAssets,
  setProductTitle,
  typeTemplate = null,a,
  headerBanner,
  productConnections,
  productSliderAssets,
  cgOptionTitle
}) => {
  const [extraProperties, setExtraProperties] = useState(null);
  const [embVisibility, setEmbVisibility] = useState(false);
  const [embroiderySwatchData, setEmbroiderySwatchData] = useState(null);
  const [swatchData, setSwatchData] = useState(null);
  const [currentVariant, setCurrentVariant] = useState(
    thisProductPage.currentVariant
  );
  const [activeQty, setActiveQty] = useState(1);
  const [currentCount, setCurrentCount] = useState(1);
  const [nonEmbProduct, setNonEmbProduct] = useState(false);
  const[selectedProduct,setSelectedProduct]= useState(productObject);
  const[selectedProductOptionVals,setSelectedProductOptionVals]= useState();
  const[selectedProductVariantInfo,setSelectedProductVariantInfo]= useState();

  const isGiftCard = selectedProduct.type.toLowerCase().includes("gift card");
  const embTag = selectedProduct.tags.filter((tag) =>
    tag.includes("embroidery")
  );
  const isEmb = embTag.length > 0;
  const noBanner = selectedProduct.tags.some((tag) =>
    tag.includes("No Sale Banner")
  );

  const addToCart = () => {
    const properties={};
    if (selectedProductVariantInfo?.product_variant_info[0]?.metafields?.embroidery_color) {
      properties['Embroidery Color'] = selectedProductVariantInfo?.product_variant_info[0]?.metafields?.embroidery_color;
    }
    if (selectedProductVariantInfo?.product_variant_info[0]?.metafields?.embroidery_style) {
      properties['Embroidery Style'] = selectedProductVariantInfo?.product_variant_info[0]?.metafields?.embroidery_style;
    }
    if (selectedProductVariantInfo?.product_variant_info[0]?.metafields?.embroidery_text) {
      properties['Embroidery Text'] = selectedProductVariantInfo?.product_variant_info[0]?.metafields?.embroidery_text;
    }
    if (selectedProductVariantInfo?.product_variant_info[0]?.metafields?.embroidery_applique_background) {
      properties['Embroidery Applique Background'] = selectedProductVariantInfo?.product_variant_info[0]?.metafields?.embroidery_applique_background;
    }
    if(selectedProductVariantInfo?.product_variant_info[0]?.metafields?.embroidery_text == 'Icon' && !selectedProductVariantInfo?.product_variant_info[0]?.metafields?.embroidery_color){
      properties['Embroidery Color'] = "";
      }
    rApp.MinicartComponent.addVariant(
      currentVariant.id,
      activeQty,
      properties
    );
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "add_to_cart_track",
      ecommerce: {
        currency: getCurrency(),
        value: Number(
          util
            .formatMoney(currentVariant.price, "${{amount}}")
            .replace("$", "")
            .replace(",", "")
        ),
        items: [
          {
            item_list_id: `${selectedProduct.id}`,
            item_list_name: `${selectedProduct.title}`,
            item_id: `${currentVariant.id}`,
            item_name: `${selectedProduct.title}`,
            affiliation: "Weezie Towels",
            currency: getCurrency(),
            coupon: null,
            discount: currentVariant?.compare_at_price
              ? util
                  .formatMoney(currentVariant?.compare_at_price, "${{amount}}")
                  .replace("$", "")
                  .replace(",", "") -
                util
                  .formatMoney(currentVariant?.price, "${{amount}}")
                  .replace("$", "")
                  .replace(",", "")
              : 0,
            index: 0,
            item_brand: "Weezie Towels",
            item_category: `${selectedProduct.type}`,
            item_category2: `${currentVariant.option1}`,
            item_category3: null,
            item_category4: null,
            item_variant: null,
            price: Number(
              util
                .formatMoney(currentVariant.price, "${{amount}}")
                .replace("$", "")
                .replace(",", "")
            ),
            quantity: currentCount,
          },
        ],
      },
    });
  };
  
  const getExtraData = () => {
    if(selectedProductVariantInfo){
    const embroideryData = selectedProductVariantInfo?.product_variant_info.filter(
      (variant) =>
        !variant.title.includes("No Embroidery") &&
        !variant.title.includes("No Custom Embroidery")
    );
    const noEmbroideryData = selectedProductVariantInfo?.product_variant_info.filter(
      (variant) =>
        variant.title.includes("No Embroidery") ||
        variant.title.includes("No Custom Embroidery")
    );

    if (noEmbroideryData.length === 0) {
      setSwatchData(selectedProductVariantInfo.product_variant_info);
    } else {
      setSwatchData(noEmbroideryData);
    }

    setEmbroiderySwatchData(embroideryData);
    }
  };

  useEffect(() => {
    const selectedOptionVals = productOptionVals.find(item => item.id === selectedProduct.id);
    const selectedVariantsInfo=productAdditionalVariantField.find(item => item.id === selectedProduct.id)
    const selectedSliderAssets=productSliderAssets.find(item => item.id === selectedProduct.id)
    setSelectedProductOptionVals(selectedOptionVals);
    setSelectedProductVariantInfo(selectedVariantsInfo)
    setProductSliderAssets(selectedSliderAssets)
  }, [selectedProduct]); 

  useEffect(() => {
    getExtraData();
  }, [currentVariant,selectedProductVariantInfo]);
  const handleProductSelection = (selectedProduct) => {
    // Ensure a valid product is provided
    if (!selectedProduct) return;
  
    // Set selected product and its first variant
    setSelectedProduct(selectedProduct);
    setCurrentVariant(selectedProduct.variants[0]);
  
    // Find the options for the selected product from the list
    const selectedProductOptions = productOptionVals.find(
      (optionVal) => optionVal.id === selectedProduct.id
    );
    const selectedVariantsInfo=productAdditionalVariantField.find(item => item.id === selectedProduct.id)
    const selectedSliderAssets=productSliderAssets.find(item => item.id === selectedProduct.id)
    // Update the selected options
    setSelectedProductOptionVals(selectedProductOptions);
    setSelectedProductVariantInfo(selectedVariantsInfo)
    setProductSliderAssets(selectedSliderAssets)
    setProductTitle(selectedProduct.title,selectedProductOptions,selectedProduct)
  };
  useEffect(() => {
    if (typeof window.yotpo !== "undefined") 
       { window.yotpo.initWidgets();
        }
      }, [selectedProduct]);
  
  return (
    <div className="react__productmeta">
      <div className="product__pricing type">
        {currentVariant?.compare_at_price &&
        currentVariant?.compare_at_price > currentVariant?.price ? (
          <>
            <s>
              {util
                .formatMoney(currentVariant.compare_at_price, "${{amount}}")
                .replace(".00", "")}
            </s>
            <span className="type--bold">
              {util
                .formatMoney(currentVariant.price, "${{amount}}")
                .replace(".00", "")}
              {visitorCountry === "CA" && " CAD"}
            </span>
            <p className="type--small">
              {Math.floor(
                100 -
                  100 *
                    Math.abs(
                      currentVariant.price / currentVariant.compare_at_price
                    )
              )}
              % off
            </p>
          </>
        ) : (
          <span>
            {util
              .formatMoney(currentVariant.price, "${{amount}}")
              .replace(".00", "")}
            {visitorCountry === "CA" && " CAD"}
          </span>
        )}

        {/* {discountMessage && (
          <p className="product__discount-message type type--small">
            {discountMessage}
          </p>
        )} */}
      </div>
      {productConnections?.length > 0 && (
        <div className="connection_wrapper">
          <p>{cgOptionTitle?cgOptionTitle:"Type"} : {productOptionVals.find((option) => option.id == selectedProduct.id)?.product_short_name}</p>
           <div className="product_connections">
          {productConnections.map((product) => {
            return (
              <div className="product_tile" key={product.id}>
                <button
                  key={product.id}
                  onClick={() => handleProductSelection(product)}
                  className={`product__variants__item-inner product__variants__item-inner-size connected_product ${
                    selectedProduct.id === product.id ? "current" : ""
                  }`}
                >
                  {
                    productOptionVals.find((option) => option.id == product.id)
                      ?.product_short_name
                  }
                </button>
                {product.tags.some(tag => tag.toLowerCase().startsWith("save badge")) && (
                  <span className="discount-badge">
                  {product.tags?.find(tag => tag.toLowerCase().startsWith("save badge")).split(":")[1].trim()}
              </span>
                )} 
              </div>
            );
          })}
        </div>
        </div>
      )}
      {!noBanner && <ProductBanner headerBanner={headerBanner} />}
      {selectedProductOptionVals&&selectedProductVariantInfo&&<Variants
        extraProperties={extraProperties}
        setExtraProperties={(props) => setExtraProperties(props)}
        setMetaCurrentVariant={(variant) => {
          setProductClassCurrentVariant(variant);
          setCurrentVariant(variant);
        }}
        openEmbModal={() => setEmbVisibility(true)}
        productOptionVals={selectedProductOptionVals?.options_with_values}
        productObject={selectedProduct}
        productPage={thisProductPage}
        productData={swatchData}
        setCurrentCount={(count) => setCurrentCount(count)}
        activeQty={activeQty}
        setActiveQty={setActiveQty}
        sizeGuideType={selectedProductOptionVals?.sizeGuideType}
      />}

      {!selectedProduct.variants.filter(
        (variant) => variant.id === currentVariant.id
      )[0].available &&
      selectedProductVariantInfo?.product_variant_info.filter(
        (variant) => variant.id === currentVariant.id
      )[0].metafields.variant_state === "notify-me" ? (
        <div className="product__notify">
          <p className="product__notify__title type type--medium">
            We’ll let you know when it’s back!
          </p>
          <form
            className="product__notify__form"
            onSubmit={(event) => notifyMe(event, email, currentVariant.id)}
            aria-label="Product notify when back in stock button"
          >
            {/* TODO: DISCUSS IF BELOW IS STILL NEEDED */}
            {/* <input className="product__notify__input type" type="text" placeholder="Your Email" onChange={event => setEmail(event.target.value)}></input>
            <button className="btn btn--navy">Notify Me</button> */}
            <a className="klaviyo-bis-trigger btn btn--navy btn--full" href="#">
              Notify Me When Available
            </a>
          </form>
        </div>
      ) : typeTemplate == "applique" ? (
        <div>
          {currentVariant.option1 !== "Custom" && selectedProductVariantInfo&& (
            <div className="product__buttons__group">
              {currentVariant.available ? (
                <button
                  onClick={() => setEmbVisibility(true)}
                  className="product__buttons__add btn btn--full btn--navy"
                  ss-track-cart-add={currentVariant.sku}
                >
                  {selectedProductVariantInfo?.product_variant_info.filter(
                    (variant) => variant.id === currentVariant.id
                  )[0].inventory_quantity <= 0 &&
                  !currentVariant.name.includes("Gift Card")
                    ? "Preorder"
                    : "Personalize and Add to Bag"}
                  {/* TODO: DISCUSS IF BELOW IS STILL NEEDED */}
                  {/* {currentCount > 1 && <span>Each</span>} */}
                </button>
              ) : (
                <button className="product__buttons__add btn btn--full btn--navy sold-out">
                  Sold Out
                </button>
              )}

              {/* TODO: COMMENTED OUT AS PART OF ORIGINAL DESIGN PIVOT */}
              {/* <button className="product__wishlist-add">
                <HeartIcon elClass="product__wishlist-add__icon" />
              </button> */}
            </div>
          )}
        </div>
      ) : (
        <div className="product__buttons">
          {isEmb &&
            currentVariant.available &&
            !isGiftCard &&
            !selectedProductVariantInfo?.product_variant_info.filter(
              (variant) => variant.id === currentVariant.id
            )[0].metafields.noEmbroidery && (
              <button
                onClick={() => {
                  setEmbVisibility(true);
                }}
                className="product__buttons__embroidery btn btn--full trigger-embroidery"
              >
                <NeedleIcon elClass="product__buttons__icon" />
                {`Personalize it • From +$${
                  visitorCountry === "CA"
                    ? (15 * conversionRateCAD).toFixed(2)
                    : 15
                } ${visitorCountry === "CA" ? "CAD" : "per item"}`}
              </button>
            )}
          <div className="product__buttons__wrap">
            <div className="product__buttons__group product__buttons__group--cart">
              {currentVariant.available ? (
                <button
                  onClick={() => addToCart()}
                  className="product__buttons__add btn btn--full btn--navy"
                  ss-track-cart-add={currentVariant.sku}
                >
                  {selectedProductVariantInfo?.product_variant_info.filter(
                    (variant) => variant.id === currentVariant.id
                  )[0].inventory_quantity <= 0 &&
                  !currentVariant.name.includes("Gift Card")
                    ? "Preorder"
                    : "Add to Bag"}
                  {/* TODO: DISCUSS IF BELOW IS STILL NEEDED */}
                  {/* {currentCount > 1 && <span>Each</span>} */}
                </button>
              ) : (
                <button className="product__buttons__add btn btn--full btn--navy sold-out">
                  Sold Out
                </button>
              )}

              {/* TODO: COMMENTED OUT AS PART OF ORIGINAL DESIGN PIVOT */}
              {/* <button className="product__wishlist-add">
                <HeartIcon elClass="product__wishlist-add__icon" />
              </button> */}
            </div>
            <div className="product__quantity">
              <div className="product__count">
                <button
                  onClick={() =>
                    setActiveQty(activeQty <= 1 ? 1 : activeQty - 1)
                  }
                  className="product__count__button product__count__button--minus"
                  aria-label="Product quantity decrease"
                >
                  <svg
                    viewBox="0 0 15 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="0.5"
                      y1="1.03623"
                      x2="14.5"
                      y2="1.03623"
                      stroke="#14334C"
                      strokeWidth="1.2"
                    />
                  </svg>
                </button>

                <span className="product__count__number type">{activeQty}</span>

                <button
                  onClick={() => setActiveQty(activeQty + 1)}
                  className="product__count__button product__count__button--plus"
                  aria-label="Product quantity increase"
                >
                  <svg viewBox="0 0 15 14" fill="none">
                    <line
                      x1="7.46377"
                      y1="2.62269e-08"
                      x2="7.46377"
                      y2="14"
                      stroke="#14334C"
                      strokeWidth="1.2"
                    />
                    <line
                      x1="0.5"
                      y1="7.03623"
                      x2="14.5"
                      y2="7.03623"
                      stroke="#14334C"
                      strokeWidth="1.2"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {
      // typeTemplate === "applique"
      //   ? isEmb &&
      //     embVisibility && (
      //       <EmbVariantsApplique
      //         setMetaCurrentVariant={(variant) => {
      //           setProductClassCurrentVariant(variant);
      //           setCurrentVariant(variant);
      //         }}
      //         singleFont={selectedFont}
      //         embTag={embTag}
      //         embVisibility={embVisibility}
      //         currentNonEmbVariant={thisProductPage.currentVariant}
      //         embroideryPricing={embroideryPricing}
      //         productOptionVals={selectedProductOptionVals.options_with_values}
      //         productObject={selectedProduct}
      //         closeEmbModal={() => setEmbVisibility(false)}
      //         productData={embroiderySwatchData}
      //         discountMessage={selectedProductOptionVals.options_with_values?.discountMessage}
      //         isApplique={typeTemplate === "applique"}
      //       />
      //     )
      //   : 
        isEmb &&
          embVisibility && (
            <EmbVariants
              setMetaCurrentVariant={(variant) => {
                setProductClassCurrentVariant(variant);
                setCurrentVariant(variant);
              }}
              isGuideVisible={
                !selectedProductVariantInfo?.product_variant_info.filter(
                  (variant) => variant.id === currentVariant.id
                )[0].metafields.noEmbroidery || false
              }
              singleFont={selectedFont}
              embTag={embTag}
              embVisibility={embVisibility}
              currentNonEmbVariant={thisProductPage.currentVariant}
              embroideryPricing={embroideryPricing}
              productOptionVals={selectedProductOptionVals.options_with_values}
              productObject={selectedProduct}
              closeEmbModal={() => setEmbVisibility(false)}
              productData={embroiderySwatchData}
              discountMessage={selectedProductOptionVals.options_with_values?.discountMessage}
              isApplique={typeTemplate === "applique"}
            />
          )}
      {/* {typeTemplate === "applique"
        ? isEmb &&
          embVisibility && (
            <EmbVariantsApplique
              setMetaCurrentVariant={(variant) => {
                setProductClassCurrentVariant(variant);
                setCurrentVariant(variant);
              }}
              singleFont={selectedFont}
              embTag={embTag}
              embVisibility={embVisibility}
              currentNonEmbVariant={thisProductPage.currentVariant}
              embroideryPricing={embroideryPricing}
              productOptionVals={productOptionVals}
              productObject={productObject}
              closeEmbModal={() => setEmbVisibility(false)}
              productData={embroiderySwatchData}
              discountMessage={discountMessage}
            />
          )
        : isEmb &&
          embVisibility && (
            <EmbVariants
              setMetaCurrentVariant={(variant) => {
                setProductClassCurrentVariant(variant);
                setCurrentVariant(variant);
              }}
              singleFont={selectedFont}
              embTag={embTag}
              embVisibility={embVisibility}
              currentNonEmbVariant={thisProductPage.currentVariant}
              embroideryPricing={embroideryPricing}
              productOptionVals={productOptionVals}
              productObject={productObject}
              closeEmbModal={() => setEmbVisibility(false)}
              productData={embroiderySwatchData}
              discountMessage={discountMessage}
            />
          )} */}

      {/* GIFT REGGIE FORM - REQUIRES LOGGED IN USER WITH REGISTRY LIST ENGAGED */}
      <form
        method="post"
        action="/cart/add"
        acceptCharset="UTF-8"
        encType="multipart/form-data"
      >
        <input name="id" type="hidden" value={currentVariant.id} />

        <div className="gift-reggie-buttons">
          <div className="gift-reggie-registry-button">
            <input type="hidden" className="gift-reggie-hook" value="" />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductMeta;
